// Third-party
import React from 'react';
import classNames from 'classnames';

// Utils
import { CURRENCY } from '../../../utils/currency';
import { formatMessage } from '../../../utils/i18n';

type Props = {
  text?: string;
  className?: string;
  as?: React.ElementType;
};

const ParenthesesLabel = ({ text, className, as = 'div' }: Props) => {
  if (!text) {
    return null;
  }
  const Component = as;
  const formattedText = text === CURRENCY.MIXED ? formatMessage('Currencies.Mixed') : text;
  return <Component className={classNames('parentheses-label', className)}>{`(${formattedText})`}</Component>;
};

export default ParenthesesLabel;
